import { createSingleEntityPickerEditor, createMultipleEntityPickerEditor } from '..';
function singleSchemaPicker(schema, options) {
    return {
        ...options,
        type: String,
        editorComponent: createSingleEntityPickerEditor({
            schema,
        }),
        resolverPlugin: {
            alias: 'singleRef',
            meta: { schema },
        },
    };
}
function multipleSchemaPicker(schema, options) {
    return {
        ...options,
        type: [String],
        editorComponent: createMultipleEntityPickerEditor({
            schema,
            max: options.max,
        }),
        resolverPlugin: {
            alias: 'multipleRef',
            meta: { schema },
        },
    };
}
export const propertyBuilder = {
    singleSchemaPicker,
    multipleSchemaPicker,
};
